/* eslint-disable global-require */
module.exports = {
  accountingSoftware: [
    {
      ids: ['sage'],
      name: 'Sage',
      url: 'https://my-dev.chaserhq.com/connect/sage',
    },
    {
      ids: ['quickbooks', 'quickbooks online', 'quickbooksonline'],
      name: 'QuickBooks Online',
      url: 'https://my-dev.chaserhq.com/connect/qbo',
    },
    {
      ids: ['xero'],
      name: 'Xero',
      url: 'https://my.chaserhq.com/connect/xero',
    },
    {
      ids: ['freeagent'],
      name: 'FreeAgent',
      url: 'https://my-dev.chaserhq.com/connect/freeagent',
    },
    {
      ids: ['freshbooks'],
      name: 'FreshBooks',
      url: 'https://my-dev.chaserhq.com/connect/freshbooks',
    },
    {
      ids: ['myobaccountright'],
      name: 'MYOB',
      url: 'https://my-dev.chaserhq.com/connect/myobaccountright',
    },
    {
      ids: ['accountsiq'],
      name: 'AccountsIQ',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['csv'],
      name: 'CSV',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['dynamics365businesscentral'],
      name: 'Dynamics 365 Business Central',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['sage200cloud'],
      name: 'Sage 200 Cloud',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['zohobooks'],
      name: 'Zoho Books',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['openapi'],
      name: 'Open API',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['sage50'],
      name: 'Sage 50',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['sage200'],
      name: 'Sage 200',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['d365bc'],
      name: 'Dynamics 365 Business Central',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['netsuite'],
      name: 'Netsuite',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['odoo'],
      name: 'Odoo',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
    {
      ids: ['sageintacct'],
      name: 'Sage Intacct',
      url: 'https://my-dev.chaserhq.com/connect/',
    },
  ],
  mpKey: '5ea67cead72fa013f4c1664ff880c1ba',
  webAppUrl: 'https://my.chaserhq.com',
  host: 'http://localhost:8081',
  admin: 'https://hub-dev-old.chaserhq.com/admin',
  helpCentre: 'https://help.chaserhq.com/',
};
